<template>
	<div class="mis-entradas">
		<h1>Mis entradas</h1>
		<span class="subtitle">A continuación se muestran tus entradas. Descárgalas y muéstralas al boletero en la puerta de acceso.</span>
		<div class="mis-entradas-main" v-if="!isCargandoTickets">
			<div class="tickets-container" v-if="!isCargandoTickets && ticketsActivos.length > 0">
				<div class="ticket" :class="{ 'ticket-abono': ticket.EspectaculoEsAbono }" v-for="ticket in ticketsActivos" :key="ticket.TicketId">
					<div class="ticket-top">
						<div class="transferencia" v-if="ticket.TicketTipo === 'T'">TRANSFERENCIA DE BUTACA</div>
						<span class="title-espectaculo">{{ ticket.EspectaculoNombre }}</span>
						<span class="dato">{{ ticket.CompetenciaNombre }}</span>
						<span class="dato">{{ ticket.EscenarioNombre }}</span>
					</div>
					<div class="ticket-main">
						<span class="title">Datos del espectador</span>
						<span class="dato">{{ ticket.PersonaNombre }} {{ ticket.PersonaApellido }}</span>
						<span class="dato">{{ ticket.PersonaDocumento }}</span>
						<span class="dato" v-if="ticket.PersonaSocioNro">Socio #{{ ticket.PersonaSocioNro }}</span>
						<span class="dato" v-else>&nbsp;</span>
						<span class="title">Datos del ticket</span>
						<span class="dato">{{ ticket.TribunaNombre }} <span>/ {{ ticket.SectorDescripcion }}</span> <span v-if="ticket.FilaNombre">/ {{ ticket.FilaNombre }}</span> <span v-if="ticket.AsientoNombre">/ {{ ticket.AsientoNombre }}</span></span>
					</div>
					<a :href="ticket.TicketURLS3" target="_blank" class="ticket-bottom" v-if="ticket.TicketGeneradoEnS3">
						<download-icon></download-icon>
						<span>Descargar entrada</span>
					</a>
					<div class="ticket-bottom ticket-bottom-generando" v-if="!ticket.TicketGeneradoEnS3"><span>Generando ticket...</span></div>
					<div class="generando-ticket" v-if="!ticket.TicketGeneradoEnS3">
						<span>¡Su ticket fue emitido con éxito! Estamos generando el ticket digital, a la brevedad te lo haremos llegar a tu correo electrónico, o lo podrás descargar desde esta página.</span>
					</div>
				</div>
			</div>
			<div class="sin-tickets" v-if="!isCargandoTickets && ticketsActivos.length === 0">
				No hay entradas activas
			</div>
			<div class="mostrar-mas-container">
				<button @click="mostrarMasActivos()" v-if="isHayMasActivos && !isCargandoTickets">
					Mostrar más tickets
				</button>
			</div>
			<div class="noticias-content" v-if="!isCargandoTickets && SDTNoticias.length > 0">
				<h3>Quizás te pueda interesar</h3>
				<div class="noticias">
					<div class="noticia" v-for="noticia in SDTNoticias" :key="noticia.NoticiaId">
						<a :href="noticia.NoticiaLink" v-if="noticia.NoticiaTipo !== 'G'">
							<div class="noticia-img" :style="{ 'background-image': 'url(' + noticia.NoticiaImagen + ')' }"></div>
							<div class="noticia-main">
								<span class="noticia-title">{{ noticia.NoticiaTitulo }}</span>
								<div class="noticia-bottom" v-if="noticia.NoticiaFecha !== '0000-00-00' || noticia.NoticiaCategoria">
									<span class="noticia-categoria" v-if="noticia.NoticiaCategoria">{{ noticia.NoticiaCategoria }}  | </span>
									<span class="noticia-fecha" v-if="noticia.NoticiaFecha !== '0000-00-00'">{{ noticia.NoticiaFecha }}</span>
								</div>
							</div>
						</a>
						<a :href="noticia.NoticiaLink" class="galeria" v-else>
							<div class="noticia-img-galeria" :style="{ 'background-image': 'url(' + noticia.NoticiaImagen + ')' }"></div>
							<div class="noticia-main-galeria">
								<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" fill-rule="evenodd"><polygon points="0 0 24 0 24 24 0 24"></polygon><path fill="#161616" d="M20.5,8.0305 L20.5,20.4971667 L3.5,20.4971667 L3.5,8.0305 L20.5,8.0305 Z M17.6666667,5.7695 L17.6666667,6.90283333 L6.33333333,6.90283333 L6.33333333,5.7695 L17.6666667,5.7695 Z M14.8333333,3.50283333 L14.8333333,4.63616667 L9.16666667,4.63616667 L9.16666667,3.50283333 L14.8333333,3.50283333 Z"></path></g></svg>
								<span class="noticia-title">{{ noticia.NoticiaTitulo }}</span>
								<div class="noticia-bottom" v-if="noticia.NoticiaFecha !== '0000-00-00' || noticia.NoticiaCategoria">
									<span class="noticia-categoria" v-if="noticia.NoticiaCategoria">{{ noticia.NoticiaCategoria }}  | </span>
									<span class="noticia-fecha" v-if="noticia.NoticiaFecha !== '0000-00-00'">{{ noticia.NoticiaFecha }}</span>
								</div>
							</div>
						</a>
					</div>
				</div>
			</div>
			<h3 v-if="!isCargandoTickets && ticketsAnteriores.length > 0">Espectáculos pasados</h3>
			<div class="tickets-container" v-if="!isCargandoTickets && ticketsAnteriores.length > 0">
				<div class="ticket ticket-anterior" v-for="ticket in ticketsAnteriores" :key="ticket.TicketId">
					<div class="ticket-top">
						<div class="transferencia" v-if="ticket.TicketTipo === 'T'">TRANSFERENCIA DE BUTACA</div>
						<span class="title-espectaculo">{{ ticket.EspectaculoNombre }}</span>
						<span class="dato">{{ ticket.CompetenciaNombre }}</span>
						<span class="dato">{{ ticket.EscenarioNombre }}</span>
					</div>
					<div class="ticket-main">
						<span class="title">Datos del espectador</span>
						<span class="dato">{{ ticket.PersonaNombre }} {{ ticket.PersonaApellido }}</span>
						<span class="dato">{{ ticket.PersonaDocumento }}</span>
						<span class="dato" v-if="ticket.PersonaSocioNro">Socio #{{ ticket.PersonaSocioNro }}</span>
						<span class="dato" v-else>&nbsp;</span>
						<span class="title">Datos del ticket</span>
						<span class="dato">{{ ticket.TribunaNombre }} <span>/ {{ ticket.SectorDescripcion }}</span> <span v-if="ticket.FilaNombre">/ {{ ticket.FilaNombre }}</span> <span v-if="ticket.AsientoNombre">/ {{ ticket.AsientoNombre }}</span></span>
					</div>
				</div>
			</div>
			<div class="mostrar-mas-container">
				<button @click="mostrarMasAnteriores()" v-if="isHayMasAnteriores && !isCargandoTickets">
					Mostrar más tickets
				</button>
			</div>
		</div>
		<div class="mis-entradas-loader" v-if="isCargandoTickets">
			<clip-loader :color="'var(--color-blue)'" :size="'52px'" v-if="isCargandoTickets"></clip-loader>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	import { DownloadIcon } from 'vue-feather-icons'
	import ClipLoader from 'vue-spinner/src/ClipLoader.vue'

	export default {
		data() {
			return {
				isCargandoTickets: true,

				usuarioId: localStorage.getItem('usuario_id'),
				ticketsActivos: [],
				ticketsAnteriores: [],
				iterActivos: 0,
				iterAnteriores: 0,
				isHayMasActivos: true,
				isHayMasAnteriores: true,
				cantidadIntentos: 0,

				// Noticias
				SDTNoticias: [],
			}
		},
		components: {
			DownloadIcon,
			ClipLoader
		},
		computed: {
			cantidadTicketsSinGenerar(){
				let cant = 0

				this.ticketsActivos.forEach((t) => {
					if(t.TicketGeneradoEnS3 === false){
						cant = cant + 1
					}
				});

				return cant
			}
		},
		async mounted(){
			// this.$store.dispatch('cargando', true);
			this.isCargandoTickets = true
			await this.cargoTickets();
			await this.obtenerNoticias();
			this.isCargandoTickets = false
			// this.$store.dispatch('cargando', false);
		},
		watch: {
			ticketsActivos(newticketsActivos){
				this.ticketsActivos.forEach((t, index) => {
					if(t.TicketGeneradoEnS3 === false){
						this.timeoutCheckearTicket(t.TicketId, t.TicketURLS3Bucket, index);
					}
				});
			}
		},
		methods: {
			async cargoTickets(){
				try {
					let response = await axios.post('/WSTicketListar', {
						UsuarioId: this.usuarioId,
						IteracionActivos: this.iterActivos, 
						IteracionAnteriores: this.iterAnteriores
					}, { headers: {"Authorization" : `Bearer ${this.$store.state.token}`} });

					if(response.data.ErrorCod === 11 || response.data.ErrorCod === 10 || response.data.ErrorCod === 1){
						this.$store.dispatch('destroyToken').then(response => {this.$router.push({ name: 'login' })})
					} else {
						if(response.data.ErrorCod === 0){
							if(response.data.SDTTicketsPasados.length < 5){
								this.isHayMasAnteriores = false
							}

							if(response.data.SDTTicketsActivos.length < 5){
								this.isHayMasActivos = false
							}
							
							this.ticketsActivos = response.data.SDTTicketsActivos;
							this.ticketsAnteriores = response.data.SDTTicketsPasados;
						}
					}
				} catch (error) {
					this.$router.push({ name: 'error' });
				}
			},
			timeout(){
				return new Promise(resolve => setTimeout(resolve, 5000));
			},
			async timeoutCheckearTicket(ticketId, urlS3, index){
				do {
					await this.timeout();
					await this.checkearTicketGenerado(ticketId, urlS3);
				} while (this.ticketsActivos[index].TicketGeneradoEnS3 === false)
			},
			async checkearTicketGenerado(ticketId, urlS3){
				try {
					if(this.cantidadIntentos <= 5 * this.cantidadTicketsSinGenerar){
						let response = await fetch(urlS3);

						if(response.status === 200){
							let indexEmitidos = this.ticketsActivos.map(ticket => ticket.TicketId).indexOf(ticketId)
							this.ticketsActivos[indexEmitidos].TicketGeneradoEnS3 = true;

							this.cantidadIntentos = this.cantidadIntentos + 1
						} else {
							this.cantidadIntentos = this.cantidadIntentos + 1
							console.log('Ocurrió un error al checkear generación del PDF')
						}
					}
				} catch (error) {
					console.log('Ocurrió un error al checkear generacion del PDF')
				}
			},
			async obtenerNoticias(){
				try {
					let response = await axios.post('/WSNoticias', {});

					if(response.data.ErrorCod === 0){
						this.SDTNoticias = response.data.SDTNoticias;
					} else {
						this.SDTNoticias = [];
					}
				} catch (error) {
					this.SDTNoticias = [];
					console.log('Ocurrió un error al intentar obtener las noticias');
				}
			},
			async mostrarMasAnteriores(){
				try {
					this.isCargandoTickets = true
					this.iterAnteriores = this.iterAnteriores + 1

					let response = await axios.post('/WSTicketListar', { 
						UsuarioId: this.usuarioId, 
						IteracionActivos: this.iterActivos, 
						IteracionAnteriores: this.iterAnteriores
					}, { headers: {"Authorization" : `Bearer ${this.$store.state.token}`} });

					if(response.data.ErrorCod === 11 || response.data.ErrorCod === 10 || response.data.ErrorCod === 1){
						this.$store.dispatch('destroyToken').then(response => {this.$router.push({ name: 'login' })})
					} else {
						if(response.data.ErrorCod === 0){
							if(response.data.SDTTicketsPasados.length < 5){
								this.isHayMasAnteriores = false
							}

							response.data.SDTTicketsPasados.map((t)=>{
								this.ticketsAnteriores.push(t);
							});
						}
					}
				} catch (error) {
					this.$router.push({ name: 'error' });
				} finally {
					this.isCargandoTickets = false
				}
			},
			async mostrarMasActivos(){
				try {
					this.isCargandoTickets = true
					this.iterActivos = this.iterActivos + 1

					let response = await axios.post('/WSTicketListar', {
						UsuarioId: this.usuarioId,
						IteracionActivos: this.iterActivos,
						IteracionAnteriores: this.iterAnteriores
					}, { headers: {"Authorization" : `Bearer ${this.$store.state.token}`} });

					if(response.data.ErrorCod === 11 || response.data.ErrorCod === 10 || response.data.ErrorCod === 1){
						this.$store.dispatch('destroyToken').then(response => {this.$router.push({ name: 'login' })})
					} else {
						if(response.data.ErrorCod === 0){
							if(response.data.SDTTicketsActivos.length < 5){
								this.isHayMasActivos = false
							}

							response.data.SDTTicketsActivos.map((t)=>{
								this.ticketsActivos.push(t);
							});
						}
					}
				} catch (error) {
					this.$router.push({ name: 'error' });
				} finally {
					this.isCargandoTickets = false
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.spinner-descarga{
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		z-index: 999;
		@include flex(column, center, center);

		span{
			margin-top: 10px;
			font-size: 14px;
			color: var(--color-blue-dark);
			font-family: var(--font-family-fira);
			font-weight: bold;
			line-height: 1.3em;
		}
	}

	.v-spinner-overlay{
		width: 100%;
		height: 100%;
		z-index: 100;
		opacity: 0.92;
		transition: all .2s;
		left: 0;
		top: 0;
		position: absolute;
		background: var(--color-white);
		border-radius: 4px;
	}
	
	.mis-entradas{
		width: 100%;
		@include flex(column, flex-start, flex-start);

		h1{
			margin: 0;
			color: var(--color-red);
			font-weight: initial;
			font-size: 48px;
			line-height: 46px;
			font-family: var(--font-family-kapra-bold);
			text-transform: uppercase;
		}

		span.subtitle{
			font-size: 18px;
			line-height: 22px;
			font-family: var(--font-family-fira);
			font-weight: bold;
			color: var(--color-dark);
		}

		.mis-entradas-loader{
			width: 100%;
			margin: 80px 0px;
			@include flex(row, center, center);
		}

		.mis-entradas-main{
			width: 100%;
			margin: 30px 0 20px 0;

			.sin-tickets{
				width: 100%;
				margin: 20px 0;
				font-size: 16px;
				font-family: var(--font-family-fira);
				background-color: var(--color-white);
				@include flex(row, center, center);
				padding: 40px 20px;
				border: 1px dashed var(--color-grey-light);
			}

			h3{
				text-transform: uppercase;
				color: var(--color-blue-dark);
				font-family: var(--font-family-kapra-bold);
				-webkit-letter-spacing: 0;
				-moz-letter-spacing: 0;
				-ms-letter-spacing: 0;
				letter-spacing: 0;
				font-size: 32px;
				line-height: 32px;
				margin-bottom: 20px;
				font-weight: var(--font-weight-bold);
			}

			.tickets-container{
				width: 100%;
				margin: 0px 0 20px 0;
				display: grid;
				grid-template-columns: repeat(3, 1fr);
				// grid-auto-rows: 1fr;
				grid-column-gap: 20px;
				grid-row-gap: 20px;

				.ticket{
					background-color: var(--color-white);
					box-shadow: 0 2px 28px 0 rgba(0, 0, 0, 0.1);
					padding: 20px;
					// padding-bottom: 28px;
					position: relative;

					// &:after{
					// 	content: '';
					// 	position: absolute;
					// 	width: 50%;
					// 	bottom: 0;
					// 	left: 0;
					// 	background-color: var(--color-blue-dark);
					// 	height: 8px;
					// 	// border-radius: 0 0 0 6px;
					// }

					// &:before{
					// 	content: '';
					// 	position: absolute;
					// 	width: 50%;
					// 	bottom: 0;
					// 	right: 0;
					// 	background-color: var(--color-red);
					// 	height: 8px;
					// 	// border-radius: 0 0 6px 0;
					// }

					.transferencia{
						background-color: var(--color-blue-dark);
						font-size: 10px;
						text-transform: uppercase;
						color: var(--color-white);
						font-weight: 400;
						padding: 4px 8px;
						margin-bottom: 5px;
					}

					span.dato{
						font-size: 13px;
						line-height: 20px;
						font-family: var(--font-family-poppins);
						font-weight: 700;
						color: var(--color-dark);
						text-transform: uppercase;
					}

					span.title{
						// text-transform: uppercase;
						font-size: 13px;
						line-height: 22px;
						font-family: var(--font-family-fira);
						font-weight: 400;
						color: var(--color-red);
					}

					span.title-espectaculo{
						margin: 0;
						color: var(--color-blue-dark);
						font-weight: initial;
						font-size: 26px;
						line-height: 1em;
						font-family: var(--font-family-kapra-bold);
						text-transform: uppercase;
						margin-bottom: 10px;
					}

					.ticket-top{
						width: 100%;
						@include flex(column, flex-start, flex-start);
						padding-bottom: 10px;
						margin-bottom: 5px;
						border-bottom: 1px dashed #ccc;
					}

					.ticket-main{
						width: 100%;
						@include flex(column, flex-start, flex-start);
						padding-bottom: 10px;
						margin-bottom: 5px;
					}

					.ticket-bottom{
						text-decoration: none;
						width: 100%;
						border: 1px solid var(--color-red);
						background-color: var(--color-red);
						border-radius: 0px;
						padding: 7px 15px;
						cursor: pointer;
						@include flex(row, center, center);
						transition: all .2s;

						svg{
							color: var(--color-white);
							width: 14px;
							height: 14px;
							margin-right: 8px;
							stroke-width: 3px;
							margin-top: -1px;
						}

						span{
							font-weight: var(--font-weight-bold);
							font-family: var(--font-family-poppins);
							color: var(--color-white);
							font-weight: 800;
							font-size: 11px;
							letter-spacing: 1px;
							text-transform: uppercase;
						}

						&:hover{
							background-color: var(--color-blue);
							border-color: var(--color-blue);

							svg, span{
								color: var(--color-white);
							}
						}

						&.ticket-bottom-generando{
							background-color: #ccc;
							border-color: #ccc;
							margin-bottom: 5px;
							cursor: auto;

							span{
								color: var(--color-dark);
							}
						}
					}

					.generando-ticket{
						font-family: var(--font-family-fira);
						font-size: 12px;
						font-weight: 400;
						line-height: 1.4em;
						padding: 0px;
						text-align: center;
						color: var(--color-dark);
						position: relative;
					}

					&.ticket-anterior{
						-webkit-filter: grayscale(100%);
						-moz-filter: grayscale(100%);
						-ms-filter: grayscale(100%);
						-o-filter: grayscale(100%);
						filter: gray;


						.ticket-main{
							padding-bottom: 0;
							margin-bottom: 0;
						}
					}

					&.ticket-abono{
						background-color: var(--color-red);

						.generando-ticket{
							color: var(--color-white);
						}

						span.dato{
							color: var(--color-white);
						}

						span.title{
							color: var(--color-blue-light);
						}

						span.title-espectaculo{
							color: var(--color-white);
						}

						.ticket-top{
							border-bottom: 1px dashed var(--color-white);
						}

						.ticket-bottom{
							width: 100%;
							border: 1px solid var(--color-blue);
							background-color: var(--color-blue);

							svg{
								color: var(--color-white);
							}

							span{
								color: var(--color-white);
							}

							&:hover{
								background-color: var(--color-blue-dark);
								border-color: var(--color-blue-dark);

								svg, span{
									color: var(--color-white);
								}
							}

							&.ticket-bottom-generando{
								&:hover{
									border: 1px solid var(--color-blue);
									background-color: var(--color-blue);
								}
							}
						}
					}
				}
			}

			.noticias-content{
				width: 100%;
				margin-top: 30px;
				margin-bottom: 20px;
				@include flex(column, flex-start, flex-start);

				h3{
					text-transform: uppercase;
					color: var(--color-blue-dark);
					font-family: var(--font-family-kapra-bold);
					-webkit-letter-spacing: 0;
					-moz-letter-spacing: 0;
					-ms-letter-spacing: 0;
					letter-spacing: 0;
					font-size: 32px;
					line-height: 32px;
					margin-bottom: 0;
					font-weight: var(--font-weight-bold);
				}

				.noticias{
					width: 100%;
					margin: 30px 0 20px 0;
					display: grid;
					grid-template-columns: repeat(3, 1fr);
					// grid-auto-rows: 1fr;
					grid-column-gap: 20px;
					grid-row-gap: 20px;
					
					.noticia{
						padding: 0px;
						position: relative;
						@include flex(column, flex-start, flex-start);
						min-height: 380px;

						a{
							width: 100%;
							height: 100%;
							@include flex(column, space-between, flex-start);
							text-decoration: none;
							box-shadow: 0 2px 28px 0 rgba(0, 0, 0, 0.1);
							-webkit-box-shadow: 0 2px 28px 0 rgba(0, 0, 0, 0.1);
							// aspect-ratio: 3 / 4;

							.noticia-img{
								width: 100%;
								height: 200px;
								background-repeat: no-repeat;
								background-size: cover;
								background-position: center;
							}

							.noticia-main{
								width: 100%;
								background-color: var(--color-white);
								padding: 20px 24px 24px;
								height: 40%;
								min-height: 180px;
								@include flex(column, space-between, flex-start);

								.noticia-title{
									width: 100%;
									font-family: var(--font-family-fira);
									font-size: 18px;
									line-height: 22px;
									font-weight: var(--font-weight-bold);
									color: var(--color-dark);
									margin-bottom: 24px;
									overflow: hidden;
									text-overflow: ellipsis;
								}

								.noticia-bottom{
									width: 100%;
									@include flex(row, flex-start, center);

									.noticia-categoria{
										font-family: var(--font-family-poppins);
										font-size: 13px;
										font-weight: bold;
										line-height: 20px;
										text-transform: uppercase;
										color: var(--color-red);
										margin-right: 4px;
									}

									.noticia-fecha{
										font-family: var(--font-family-poppins);
										font-size: 13px;
										line-height: 20px;
										text-transform: uppercase;
										color: var(--color-grey);
									}
								}
							}

							&.galeria{
								position: relative;
								@include flex(column, flex-end, flex-start);

								// &:before{
								// 	content: '';
								// 	width: 100%;
								// 	height: 60%;
								// 	left: 0;
								// 	bottom: 0;
								// 	background: linear-gradient(180deg,rgba(0,70,173,0) 0%,var(--color-blue) 100%);
								// 	z-index: 2;
								// 	position: absolute;
								// }

								.noticia-img-galeria{
									width: 100%;
									height: 100%;
									background-repeat: no-repeat;
									background-size: cover;
									background-position: center;
									position: absolute;
									top: 0;
									left: 0;
									z-index: 1;
								}

								.noticia-main-galeria{
									width: 100%;
									padding: 20px 24px 24px;
									@include flex(column, flex-end, flex-start);
									z-index: 3;

									svg{
										width: 32px;
										height: 32px;

										path{
											fill: var(--color-white);
										}
									}

									.noticia-title{
										width: 100%;
										font-family: var(--font-family-fira);
										font-size: 18px;
										line-height: 22px;
										font-weight: var(--font-weight-bold);
										color: var(--color-white);
										-webkit-line-clamp: 4;
										margin: 16px 0;
										overflow: hidden;
										text-overflow: ellipsis;
									}

									.noticia-bottom{
										width: 100%;
										@include flex(row, flex-start, center);

										.noticia-categoria{
											font-family: var(--font-family-poppins);
											font-size: 13px;
											font-weight: bold;
											line-height: 20px;
											text-transform: uppercase;
											color: var(--color-blue-light);
											margin-right: 4px;
										}

										.noticia-fecha{
											font-family: var(--font-family-poppins);
											font-size: 13px;
											line-height: 20px;
											text-transform: uppercase;
											color: var(--color-white);
										}
									}
								}
							}
						}
					}
				}
			}

			.mostrar-mas-container{
				width: 100%;
				@include flex(row, center, center);

				button{
					background-color: var(--color-blue-dark);
					padding: 8px 13px;
					line-height: 1em;
					margin: 15px 0;
					border-radius: 99px;
					outline: none;
					border: none;
					color: var(--color-white);
					font-size: 11px;
					text-transform: uppercase;
					letter-spacing: 1px;
					font-weight: var(--font-weight-bold);
					font-family: var(--font-family-poppins);
					cursor: pointer;
					transition: all .2s;

					&:hover{
						background-color: var(--color-blue);
					}
				}
			}
		}
	}

	/* Responsive */
	@media screen and (max-width: 1308px){
		.mis-entradas{
			.mis-entradas-header{
				padding-right: 24px;
				padding-left: 24px;

				.container{
					h1{
						font-size: 22px;
						line-height: 1.4em;
						margin-bottom: 5px;
					}
					
					p{
						line-height: 1.3em;
						font-size: 14px;
					}
				}
			}
			.mis-entradas-main{
				.container{
					padding-right: 24px;
					padding-left: 24px;
				}
			}
		}
	}

	@media screen and (max-width: 1240px){
		.mis-entradas{
			.mis-entradas-main{
				.container{
					.tickets-container{
						.ticket{
							width: calc(33.33% - 20px);
						}
					}
				}
			}
		}
	}

	@media screen and (max-width: 1120px) {
		.mis-entradas{
			h1{
				font-size: 38px;
				line-height: 38px;
			}
			span.subtitle{
				font-size: 16px;
				line-height: 20px;
			}
		}
	}

	@media screen and (max-width: 960px){
		.mis-entradas{
			.mis-entradas-main{
				.tickets-container{
					grid-template-columns: repeat(2, 1fr);
				}

				.noticias-content .noticias{
					grid-template-columns: repeat(2, 1fr);
				}
			}
		}
	}

	@media screen and (max-width: 720px){
		.mis-entradas{
			h1{
				font-size: 32px;
				line-height: 32px;
			}

			span.subtitle{
				font-size: 13px;
				line-height: 15px;
			}

			.mis-entradas-main{
				margin-top: 10px;

				h3{
					margin: 10px 0;
				}

				.tickets-container{
					grid-template-columns: repeat(1, 1fr);
				}

				.noticias-content .noticias{
					grid-template-columns: repeat(1, 1fr);
				}
			}
		}
	}
</style>